angular.module('storefront.account')
    .component('vcAccountOrders', {
        templateUrl: 'themes/assets/js/account/account-orders.tpl.liquid',
        $routeConfig: [
            {
                path: '/',
                name: 'OrderList',
                component: 'vcAccountOrdersList',
                useAsDefault: true,
            },
            {
                path: '/:number',
                name: 'OrderDetail',
                component: 'vcAccountOrderDetail',
            },
        ],
        controller: ['orderHelper', function (orderHelper) {
            const $ctrl = this;

            $ctrl.orderHelper = orderHelper;
        }],
    })

    .component('vcAccountOrdersList', {
        templateUrl: 'account-orders-list.tpl',
        controller: ['storefront.orderApi', 'loadingIndicatorService', function (orderApi, loader) {
            const ctrl = this;

            ctrl.loader = loader;

            ctrl.loadOrders = function () {
                loader.wrapLoading(function () {
                    return orderApi.search({
                        pageNumber: 1,
                        pageSize: 10000,
                        sortInfos: ctrl.sortInfos,
                        statuses: ['Paid', 'Shipped'],
                    }, function (data) {
                        ctrl.entries = data.results;
                    }).$promise;
                });
            };

            this.$routerOnActivate = function () {
                ctrl.loadOrders();
            };
        }],
    })

    .component('vcAccountOrderDetail', {
        templateUrl: 'themes/assets/js/account/account-order-detail.tpl.liquid',
        bindings: {
            order: '<',
            showReturn: '@',
        },
        controller: [
            'storefront.orderApi',
            '$rootScope',
            '$window',
            'loadingIndicatorService',
            'confirmService',
            'orderHelper',
            '$timeout',
            'catalogService',
            function (
                orderApi,
                $rootScope,
                $window,
                loader,
                confirmService,
                orderHelper,
                timeoutService,
                catalogService,
            ) {
                const $ctrl = this;
                let loadPromise;

                $ctrl.loader = loader;
                $ctrl.hasPhysicalProducts = true;

                if (!$ctrl.showReturn) {
                    $ctrl.showReturn = 'true';
                }

                $ctrl.returnVisible = function () {
                    return $ctrl.showReturn === 'true';
                };

                function refresh() {
                    $ctrl.orderNumber = $ctrl.order.number;
                    $ctrl.isShowPayment = false;

                    const lastPayment = _.last(_.sortBy($ctrl.order.inPayments, 'createdDate'));

                    $ctrl.billingAddress = (lastPayment && lastPayment.billingAddress)
                        || _.findWhere($ctrl.order.addresses, { type: 'billing' })
                        || _.first($ctrl.order.addresses);

                    $ctrl.amountToPay = orderHelper.getNewPayment($ctrl.order).sum.amount;

                    if ($ctrl.amountToPay > 0) {
                        $ctrl.billingAddressEqualsShipping = false;
                        loadPromise = orderApi.getNewPaymentData({
                            number: $ctrl.orderNumber,
                        }, function (result) {
                            configurePayment(result.paymentMethods, result.payment);
                        }).$promise;
                    }

                    const productsIds = _.map($ctrl.order.items, (x) => x.productId);

                    catalogService.getProducts(productsIds)
                        .then(function (response) {
                            if (response.data.length) {
                                _.each($ctrl.order.items, function (item) {
                                    item.product = {};
                                    item.product.variationProperties = _.find(
                                        response.data,
                                        (x) => x.id === item.productId,
                                    ).variationProperties;
                                });
                            }
                        });
                }

                this.$routerOnActivate = function (next) {
                    $ctrl.pageNumber = next.params.pageNumber || 1;
                    $ctrl.orderNumber = next.params.number;
                    loader.wrapLoading(function () {
                        return orderApi.get({
                            number: $ctrl.orderNumber,
                        }, function (result) {
                            $ctrl.order = result;
                            refresh();
                        }).$promise;
                    });
                };

                $ctrl.getInvoicePdf = function () {
                    const url = $window.BASE_URL + 'storefrontapi/orders/' + $ctrl.order.orderNumber + 'invoice';

                    $window.open(url, '_blank');
                };

                $ctrl.showPayment = function () {
                    loadPromise.then(function () {
                        $ctrl.isShowPayment = true;
                    });
                };

                $ctrl.getAvailPaymentMethods = function () {
                    return loadPromise.then(function (result) {
                        let preselectedMaymentMethod;

                        if ($ctrl.payment.gatewayCode) {
                            preselectedMaymentMethod = _.findWhere(result.paymentMethods, {
                                code: $ctrl.payment.gatewayCode,
                            });
                        }

                        return preselectedMaymentMethod ? [preselectedMaymentMethod] : result.paymentMethods;
                    });
                };

                $ctrl.selectPaymentMethod = function (paymentMethod) {
                    angular.extend($ctrl.payment, paymentMethod);
                    $ctrl.payment.gatewayCode = paymentMethod.code;
                    // $ctrl.payment.sum = angular.copy($ctrl.order.total);
                    // $ctrl.payment.sum.amount += paymentMethod.totalWithTax.amount;

                    $ctrl.validate();
                };

                $ctrl.validate = function () {
                    $ctrl.isValid = $ctrl.payment
                        && $ctrl.payment.gatewayCode
                        && $ctrl.payment.sum && $ctrl.payment.sum.amount > 0
                        && _.every(components, function (x) {
                            return !angular.isFunction(x.validate) || x.validate();
                        });

                    return $ctrl.isValid;
                };

                $ctrl.submit = function () {
                    if ($ctrl.validate()) {
                        loader.wrapLoading(function () {
                            $ctrl.payment.bankCardInfo = $ctrl.paymentMethod.card;
                            return orderApi.addOrUpdatePayment({
                                number: $ctrl.orderNumber,
                            }, $ctrl.payment, function (payment) {
                                orderApi.processPayment({
                                    number: $ctrl.orderNumber,
                                    paymentNumber: payment.number,
                                }, $ctrl.paymentMethod.card ? $ctrl.paymentMethod.card : {}, function (result) {
                                    const { orderProcessingResult, paymentMethod } = result;

                                    // if (!orderProcessingResult.isSuccess) {
                                    //     $rootScope.$broadcast('storefrontError', {
                                    //         type: 'error',
                                    //         title: [
                                    //             'Error in new payment processing: ',
                                    //             orderProcessingResult.error,
                                    //             'New Payment status: ' + orderProcessingResult.newPaymentStatus,
                                    //         ].join(' '),
                                    //         message: orderProcessingResult.error,
                                    //     });
                                    //     return;
                                    // }

                                    if (
                                        paymentMethod.paymentMethodType
                                        && paymentMethod.paymentMethodType.toLowerCase() === 'preparedform'
                                        && orderProcessingResult.htmlForm
                                    ) {
                                        outerRedirect($ctrl.accountManager.baseUrl
                                            + 'cart/checkout/paymentform?orderNumber=' + $ctrl.orderNumber);
                                    } else if (
                                        paymentMethod.paymentMethodType
                                        && paymentMethod.paymentMethodType.toLowerCase() === 'redirection'
                                        && orderProcessingResult.redirectUrl
                                    ) {
                                        outerRedirect(orderProcessingResult.redirectUrl);
                                    } else if ($ctrl.accountManager.customer.isRegisteredUser) {
                                        refresh();
                                    } else {
                                        outerRedirect($ctrl.accountManager.baseUrl
                                            + 'cart/thank-you/' + $ctrl.orderNumber);
                                    }
                                });
                            }).$promise;
                        });
                    }
                };

                $ctrl.cancel = function () {
                    confirmService.confirm('Cancel this payment?')
                        .then(function (confirmed) {
                            if (confirmed) {
                                loader.wrapLoading(function () {
                                    return orderApi.cancelPayment({
                                        number: $ctrl.orderNumber,
                                        paymentNumber: $ctrl.payment.number,
                                    }, null, refresh).$promise;
                                });
                            }
                        });
                };

                let components = [];
                $ctrl.addComponent = function (component) {
                    components.push(component);
                };
                $ctrl.removeComponent = function (component) {
                    components = _.without(components, component);
                };

                function configurePayment(paymentMethods, newPaymentTemplate) {
                    $ctrl.payment = orderHelper.getNewPayment($ctrl.order, paymentMethods, newPaymentTemplate);
                    $ctrl.payment.purpose = $ctrl.payment.purpose || 'Repeated payment';
                    $ctrl.amountToPay = $ctrl.payment.sum.amount;

                    $ctrl.canCancelPayment = $ctrl.payment.id !== newPaymentTemplate.id;
                    if ($ctrl.canCancelPayment) {
                        $ctrl.selectPaymentMethod(_.findWhere(paymentMethods, {
                            code: $ctrl.payment.gatewayCode,
                        }));
                    }

                    if (!_.some($ctrl.order.shipments)) {
                        $ctrl.hasPhysicalProducts = false;
                        $ctrl.billingAddressEqualsShipping = false;
                    }
                }

                function outerRedirect(absUrl) {
                    $window.location.href = absUrl;
                }

                if ($ctrl.order) {
                    refresh();
                }
            }],
    })

    .factory('orderHelper', function () {
        return {
            getNewPayment(order, paymentMethods, newPaymentTemplate) {
                let retVal;
                const paidPayments = _.filter(order.inPayments, function (x) {
                    return x.status === 'Paid';
                });
                const paidAmount = _.reduce(paidPayments, function (memo, num) {
                    return memo + num.sum.amount;
                }, 0);
                const amountToPay = order.total.amount - paidAmount;

                const pendingPayments = _.filter(order.inPayments, function (x) {
                    return !x.isCancelled
                        && (x.status === 'New' || x.status === 'Pending')
                        && x.sum.amount > 0; // && x.sum.amount === amountToPay;
                });
                const pendingPayment = _.last(_.sortBy(pendingPayments, 'createdDate'));

                if (
                    pendingPayment
                    && (!paymentMethods || _.findWhere(paymentMethods, { code: pendingPayment.gatewayCode }))
                ) {
                    retVal = pendingPayment;
                } else {
                    newPaymentTemplate = newPaymentTemplate || { sum: {} };
                    newPaymentTemplate.sum.amount = amountToPay;
                    retVal = newPaymentTemplate;
                }

                return retVal;
            },
        };
    })

    .filter('orderToSummarizedStatusLabel', ['orderHelper', function (orderHelper) {
        return function (order) {
            let retVal = order.status || 'New';

            const found = _.findWhere(orderHelper.statusLabels, {
                status: retVal.toLowerCase(),
            });
            if (found) {
                retVal = found.label;
            }

            return retVal;
        };
    }]);
